"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitSyncDeleteDatasetDistributorIndexing = void 0;
const routes_1 = require("../../routes");
const submitSyncDeleteDatasetDistributorIndexing = (client) => async (distributorId, { productIds }) => {
    const url = routes_1.ENDPOINTS.SUBMIT_DATASET_PARTNER_SYNC_DELETE_INDEXING_TASK.applyParams(distributorId);
    const { data } = await client.post(url, { productIdList: productIds });
    return data;
};
exports.submitSyncDeleteDatasetDistributorIndexing = submitSyncDeleteDatasetDistributorIndexing;
